import styled from 'styled-components';

export const LabelWithTooltipField = styled.div`
	display: flex;
	flex-direction: column-reverse;
	gap: 4px;
`;

export const GuestUserField = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

export const StatusNotice = styled.div`
	color: #6b6b76;
	font-size: 12px;
	line-height: 16px;
`;

export const DisableableSection = styled.fieldset`
	border: 0;
	padding: 0;
	margin: 0;
	min-width: 0;
	&:disabled {
		opacity: 0.5;
	}
`;

// Reserves vertical space for the design-system TextField's error line so
// toggling a required-field error on/off does not shift sibling rows below.
// Height covers label (~20px) + large input (~56px) + error text (~20px).
export const FormFieldSlot = styled.div`
	width: 100%;
`;
